
export const funcCurrentDateString = (): string => {
        const d = new Date();
        return (
                d.getFullYear().toString() +
                String(d.getMonth() + 1).padStart(2, "0") +
                String(d.getDate()).padStart(2, "0") +
                String(d.getHours()).padStart(2, "0") +
                String(d.getMinutes()).padStart(2, "0") +
                String(d.getSeconds()).padStart(2, "0") +
                String(d.getMilliseconds()).padStart(3, "0")
        );
};